module.exports = "// Activate WOW.js plugin for animation on scroll\nnew WOW().init();\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src154282656/src/www-arthcloud/~/raw-loader!/codebuild/output/src154282656/src/www-arthcloud/~/source-map-loader!/codebuild/output/src154282656/src/www-arthcloud/vendor/inspinia.js
// module id = ../../../../raw-loader/index.js!../../../../source-map-loader/index.js!../../../../../vendor/inspinia.js
// module chunks = 3